(() => {
  'use strict';
  const node = document.getElementById('BraineryDiscoveryConfig');
  const layout = document.querySelector('.br-discovery-layout');
  if (!node || !layout || window.__braineryDiscovery) return;
  window.__braineryDiscovery = true;
  const config = JSON.parse(node.textContent), s = config.strings;
  const left = layout.querySelector('.br-discovery--left'), right = layout.querySelector('.br-discovery--right');
  const nav = left?.querySelector('[data-br-discovery-nav]'), recent = left?.querySelector('[data-br-discovery-recent]');
  const wide = matchMedia('(min-width:1680px)'), productCache = new Map(), recommendationCache = new Map();
  let cart = config.cart, visible = false, request = 0, activeSeed, resizePending = false;
  const percent = n => n >= 5 ? 20 : n >= 4 ? 15 : n >= 3 ? 10 : n >= 2 ? 5 : 0;
  const target = n => n < 2 ? 2 : n < 5 ? n + 1 : 0;
  const escape = v => String(v ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const fill = (text, values) => text.replace(/\[(\w+)\]/g, (token,key) => values[key] ?? token);
  const text = (selector,value) => { const el = right.querySelector(selector); if (el && el.textContent !== value) el.textContent = value; };
  const money = value => new Intl.NumberFormat(config.locale || 'de-DE', { style:'currency', currency:config.currency || 'EUR' }).format(value / 100);
  const handleOK = h => typeof h === 'string' && /^[a-z0-9-]{1,200}$/.test(h);
  function imageURL(value) {
    if (!value) return '';
    try { const url = new URL(typeof value === 'object' ? value?.src : value, location.origin); if (url.protocol !== 'https:' && url.origin !== location.origin) return ''; url.searchParams.set('width','200'); return url.href; } catch (_) { return ''; }
  }
  function card(p,compact = false) {
    if (!handleOK(p.handle) || !p.available || p.gift_card) return '';
    const price = Number(p.price_min ?? p.price); if (!Number.isFinite(price) || price < 0) return '';
    const image = imageURL(p.featured_image || p.images?.[0]);
    return '<a class="br-discovery__product" href="'+escape(config.root+'products/'+encodeURIComponent(p.handle))+'" data-br-discovery-card="'+escape(p.id)+'">'+(image?'<img src="'+escape(image)+'" alt="'+escape(p.title)+'" width="100" height="100" loading="lazy">':'')+'<span><small>'+escape(p.vendor)+'</small><strong>'+escape(p.title)+'</strong>'+(!compact?'<b>'+(p.price_varies?escape(s.from)+' ':'')+escape(money(price))+'</b>':'')+'</span><i aria-hidden="true">↗</i></a>';
  }
  function priceStatus() {
    const count = Math.max(0, Number(cart.item_count) || 0), next = target(count), rate = percent(count);
    text('[data-br-discovery-rate]', (next ? percent(next) : rate) + ' %');
    text('[data-br-discovery-status]', count ? fill(s.status,{count,percent:rate}) : s.start);
    text('[data-br-discovery-next]', next ? fill(s.next,{count:next-count,percent:percent(next)}) : s.maximum);
    right.querySelector('[data-br-discovery-meter]').style.width = Math.min(count/5*100,100)+'%';
    const excluded = new Set((cart.items || []).map(x => String(x.product_id)));
    right.querySelectorAll('[data-br-discovery-card]').forEach(el => { el.hidden = excluded.has(el.dataset.brDiscoveryCard) || String(config.current) === el.dataset.brDiscoveryCard; });
  }
  async function recommendations(id) {
    return window.BraineryRecommendations ? window.BraineryRecommendations.get(id, config.root) : {intent:'related',products:[]};
  }
  async function loadRecommendations() {
    if (!visible) return;
    const seed = config.type === 'product' ? config.current : cart.items?.[0]?.product_id || config.seed;
    const version = ++request;
    const excluded = new Set((cart.items || []).map(x => String(x.product_id)));
    if (config.current) excluded.add(String(config.current));
    const result = seed ? await recommendations(seed) : {products:[]};
    if (version !== request) return;
    const products = result.products.filter(p => p.available && !p.gift_card && !excluded.has(String(p.id))).slice(0,3);
    const markup = products.map(p => card(p)).join('');
    const grid = right.querySelector('[data-br-discovery-products]');
    if (grid.innerHTML !== markup) grid.innerHTML = markup;
    right.querySelector('[data-br-discovery-recommendations]').hidden = !markup;
    text('[data-br-discovery-heading]', markup ? (result.intent === 'complementary' ? s.complementary : s.related) : s.discover);
    priceStatus();
  }
  function historyAllowed() {
    try { return window.Shopify?.customerPrivacy?.preferencesProcessingAllowed() === true; } catch (_) { return false; }
  }
  async function loadRecent() {
    if (!recent || !historyAllowed()) { if(recent)recent.hidden=true; return; }
    let handles;
    try { const data = JSON.parse(localStorage.getItem('brainery_recent_v1') || '[]'); handles = Array.isArray(data) ? data.filter(h => handleOK(h) && h !== config.handle).slice(0,2) : []; } catch (_) { handles=[]; }
    const products = await Promise.allSettled(handles.map(handle => {
      if (!productCache.has(handle)) productCache.set(handle,fetch(config.root+'products/'+encodeURIComponent(handle)+'.js',{credentials:'same-origin'}).then(r=>{if(!r.ok)throw Error('product');return r.json();}));
      return productCache.get(handle);
    }));
    const markup = products.filter(r=>r.status==='fulfilled').map(r=>card(r.value,true)).join('');
    recent.querySelector('[data-br-discovery-history]').innerHTML=markup;recent.hidden=!markup;
  }
  function responsive() {
    nav.open=wide.matches;
    if(recent)(wide.matches?left:right).querySelector('.br-discovery__sticky').append(recent);
    updateOffset();
  }
  function updateOffset() {
    if (resizePending) return; resizePending=true;
    requestAnimationFrame(()=>{
      resizePending=false;
      const header=document.querySelector('.shopify-section-header-sticky, sticky-header, .section-header');
      const bottom=header?Math.max(0,header.getBoundingClientRect().bottom):80;
      layout.style.setProperty('--br-discovery-top',Math.min(bottom+16,220)+'px');
    });
  }
  function setCart(value) {
    if(!value||!Number.isFinite(value.item_count))return;
    cart=value;priceStatus();
    const seed=config.type==='product'?config.current:cart.items?.[0]?.product_id||config.seed;
    if(seed!==activeSeed){activeSeed=seed;loadRecommendations();}
    else if(visible)loadRecommendations();
  }
  function init() {
    layout.dataset.brDiscoveryReady='';responsive();priceStatus();
    wide.addEventListener('change',responsive);
    nav.addEventListener('toggle',()=>{if(wide.matches&&!nav.open)nav.open=true;});
    window.addEventListener('scroll',updateOffset,{passive:true});window.addEventListener('resize',updateOffset,{passive:true});
    document.addEventListener('brainery:cart',e=>setCart(e.detail));
    document.addEventListener('visitorConsentCollected',loadRecent);
    document.addEventListener('click',e=>{if(!e.target.closest?.('[data-br-discovery-clear]'))return;try{localStorage.removeItem('brainery_recent_v1')}catch(_){}recent.hidden=true;document.querySelectorAll('[data-br-recent]').forEach(el=>el.hidden=true);});
    if(window.__braineryCart)setCart(window.__braineryCart);
    const load=()=>{visible=true;loadRecommendations();loadRecent();};
    if('IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){observer.disconnect();load();}},{rootMargin:'200px'});observer.observe(right);}else load();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();


